import { useFinanceSimulationSelector } from "@redux/reducers/deal";
import { getIsCashJourneySelected } from "@shared/v2/lib/getIsCashJourneySelected";

export const useIsCashJourneySelected = () => {
  const financeSimulation = useFinanceSimulationSelector();

  return getIsCashJourneySelected(financeSimulation.journey);
};
